import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Input, Button, Modal, Tooltip } from 'antd'
import styled from 'styled-components'
import ColorList from '../../../constants/color.constants'
import path from '../../../icons/create/Path.svg'
import loadingAnimationthreedot from 'icons/three-dots.svg'
import { GET_DATA_ACCOUNT_BY_ID } from 'api/Account/profile'
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  LeftOutlined,
  PlusOutlined,
  RightOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import unknow from '../../../icons/create/unknow.svg'
import bin from '../../../icons/create/bin.svg'
import {
  updateSkill,
  USE_SKILL_IN_PROJECT_ROLE,
  ACCOUNT_DELETE_API,
} from 'api/Project/skill'
import {
  addProfessionalSkill,
  getProfessionalSkillByProject,
} from 'api/ProfessionSkills/professionskills'
import { getProjectById } from 'api/Project/project'
import { getCookie } from 'helper/cookie'
import 'styleLess/signature/skill.scss'

import { Helmet } from 'react-helmet'
const { TextArea } = Input
const EditModal = styled(Modal)`
  width: 634px !important ;
  .Modaltitle {
    color: ${ColorList.blue};
    font-family: IBMPlexSansThaiRegular;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
  }
  .ant-modal-header {
    margin: 0px;
    border-bottom: 0px solid;
  }
  .ant-modal-footer {
    border-top: 0px solid;
  }
  .ant-btn {
    border-radius: 4px;
    border: 1px solid ${ColorList.blue};
    color: ${ColorList.blue};
  }
  .ant-btn-primary {
    background-color: ${ColorList.blue};
    color: ${ColorList.white};
  }

  button:disabled {
    border-color: #d9d9d9;
    background-color: #f5f5f5;
    color: rgba(0, 0, 0, 0.25);
  }
`
const SkillContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
`
const Footer = styled.div``
const Content = styled.div``

const initalState = {
  data: [],
  isLoading: true,
}

const Skill = (props) => {
  const {
    role,
    idEditPRJ,
    form,
    company_id,
    checkDataskill_Func,
    setPastnewData,
    setDisLoadPage,
  } = props

  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [BinVisible, SetBinVisible] = useState(false)
  const [SearchTerm, setSearchTerm] = useState('')
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [Selected, SetSelected] = useState(true)
  const [icon, Seticon] = useState(true)
  const [arrayID, SetarrayID] = useState([])
  const [Data, setData] = useState(initalState.data)
  const [using, setUsing] = useState(initalState.data)
  const [ItemName, setItemName] = useState('')
  const [Disabled, SetDisabled] = useState(true)
  const [WarningTxt, setWarningTxt] = useState(false)
  const [checkBtn, setCheckBtn] = useState('')
  const [waitingallData, setWaitingallData] = useState(false)
  const token = getCookie('access_token_admin')
  const [isModalVisibleDraft, SetisModalVisibleDraft] = useState(false)
  const [defaulskillList, setDefaultskillList] = useState('')
  const [projectSkillName, setProjectSkillName] = useState('')

  const [isModalVisibleSkill, setIsModalVisibleSkill] = useState(false)
  const [idDeleteskill, setIDDeleteskill] = useState()
  const [tagOrbox, setTagorBox] = useState('')
  const [skillName, setSkillName] = useState()
  const [accountId, setAccountId] = useState()

  const getSkillListData = async () => {
    await getProfessionalSkillByProject({
      project_id: idEditPRJ,
      company_id: company_id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setData([])
          return true
        }
        if (status === 200) {
          await setData(data)
        } else {
          setData([])
          return true
        }
      })
      .catch((error) => {
        setData([])

        console.error(error)
      })
  }

  const getDataProjectById = async () => {
    // ฟังก์ชั่นนี้โหลดเยอะไป
    await getProjectById({
      id: idEditPRJ,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          return true
        }
        if (status === 200) {
          setDefaultskillList(data.project_skill)
          setProjectSkillName(data.project_skill_name)
          setAccountId(data.account_id)
        } else {
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  const GetAccountByID = () => {
    GET_DATA_ACCOUNT_BY_ID({
      token: token,
      id: accountId,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setSkillName(data.skill_name)
          setIsLoading(false)
        } else {
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setIsLoading(false)
        console.error(error)
      })
  }
  const getProjectroleUseSkill = async () => {
    await USE_SKILL_IN_PROJECT_ROLE({
      id: idEditPRJ,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setUsing([])
          return true
        }
        if (status === 200) {
          setUsing(data)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  useEffect(async () => {
    if (token) {
      await getProjectroleUseSkill()
      await getSkillListData()
      await getDataProjectById()
      await GetAccountByID()
    }
  }, [token])
  let EmytyArray = []
  const usefuc = async (data, skillNames = []) => {
    // Reset EmytyArray ก่อนเริ่มต้น
    EmytyArray = []

    // กรองและทำความสะอาดข้อมูล
    const cleanedData = data
      .filter((item) => item && item.toString().trim() !== '') // กรอง empty string
      .map((item) => parseInt(item.toString().trim())) // แปลงเป็น number
      .filter((id) => !isNaN(id)) // กรอง NaN ออก

    // สร้าง Map จาก Data เพื่อการค้นหาที่เร็วขึ้น
    const dataMap = new Map()
    Data.forEach((item) => {
      if (item && item.id) {
        dataMap.set(item.id, item)
      }
    })

    // ประมวลผลแต่ละ ID
    cleanedData.forEach((id, index) => {
      const foundData = dataMap.get(id)

      if (foundData) {
        // พบข้อมูลใน Data (Active)
        EmytyArray.push({
          id: foundData.id,
          skill_name: foundData.title,
          isUnknown: false,
        })
      } else {
        // ไม่พบข้อมูลใน Data (Inactive) - ใช้ชื่อจาก projectSkillName
        const skillName = skillNames[index] || `Unknown Skill (${id})`
        EmytyArray.push({
          id: id,
          skill_name: skillName,
          isUnknown: true,
          isInactive: true, // flag สำหรับ inactive items
        })
      }
    })

    // อัพเดท state
    if (EmytyArray.length > 0) {
      SetBinVisible(true)
    }

    setDisLoadPage(true)
    setWaitingallData(true)

    await SetarrayID([...EmytyArray]) // ใช้ spread operator เพื่อสร้าง array ใหม่
  }
  useEffect(() => {
    if (defaulskillList != undefined) {
      var skill = defaulskillList
      if (skill != null) {
        skill = skill.substring(0, skill.length)
        var arrayskill = skill.split(',')

        // แปลง projectSkillName เป็น array
        const skillNames = projectSkillName ? projectSkillName.split(',') : []

        usefuc(arrayskill, skillNames)
      }
    }
  }, [defaulskillList, projectSkillName])

  const showModal = () => {
    SetDisabled(true)
    setIsModalVisible(true)
  }
  const handleOk = () => {
    checkInputValue('')

    setIsModalVisible(false)
  }
  const handleCancel = () => {
    setWarningTxt(false)
    setIsModalVisible(false)
    setItemName('')
  }
  const onChangeSearch = (e) => {
    setSearchTerm(e.target.value)
  }

  let Selecttotal = arrayID.length
  const handleEventSelected = (data, val) => {
    if (role === false) {
      SelectListAll(data)
      EventSelect()
      if (arrayID != null) {
        SetBinVisible(true)
      }

      arrayID.map((item) => {
        if (item.id == data.id) {
          if (val != undefined) {
            setIsModalVisibleSkill(true)
            setIDDeleteskill(data.id)
          } else {
            handleRemove(data.id)
          }
        }
      })
    }
  }
  const okEvent = () => {
    if (tagOrbox === 'alldelete') {
      RemoveAll()
      SetBinVisible(false)
      SetSelected(false)
      Seticon(false)
      setIsModalVisibleSkill(false)
    } else if (tagOrbox === 'unitdelete') {
      setIsModalVisibleSkill(false)
      handleRemove(idDeleteskill)
    } else {
      handleRemove(idDeleteskill)
      setIsModalVisibleSkill(false)
    }
    setTagorBox('')
  }
  const cancleEvent = () => {
    setIsModalVisibleSkill(false)
  }

  const SelectListAll = (data) => {
    var addData = true
    // for (var i = 0; i < arrayID.length; i++) {
    //   if (arrayID[i].id == data.id) {
    //     addData = false
    //   }
    // }

    if (addData) {
      //เงื่อนไข
      return SetarrayID([
        ...arrayID,
        {
          id: data.id,
          skill_name: data.title,
        },
      ])
    }
  }
  const EventSelect = () => {
    SetSelected(true)
    Seticon(true)
  }

  // ================== Select Function ==================

  const checkInputValue = (value) => {
    if (value === '' || value.match(/^ *$/) !== null) {
      SetDisabled(true)
    } else {
      SetDisabled(false)
    }
    setItemName(value)
  }

  const addItem = (event) => {
    if (
      Data.find((data) => data.title.toLocaleLowerCase() === ItemName.toLocaleLowerCase())
    ) {
      return setWarningTxt(true)
    } else afunc()
  }

  const afunc = async (event) => {
    const dataArray = {
      company_id: parseInt(company_id),
      project_id: parseInt(idEditPRJ),
      title: ItemName,
      title_en: '',
    }
    try {
      addProfessionalSkill({
        params: dataArray,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getSkillListData()
        }
      })
    } catch (error) {
      console.log(error)
    }

    setItemName('')
    setWarningTxt(false)

    handleOk()
  }

  const eventtagFunctional = (values, id) => {
    if (role !== true) {
      if (values === 'onetag') {
        if (using[id] != undefined) {
          setIsModalVisibleSkill(true)
          setTagorBox('unitdelete')
          setIDDeleteskill(id)
        } else {
          handleRemove(id)
        }
      } else if (values === 'multitag') {
        RemoveAll()
        SetBinVisible(false)
        SetSelected(false)
        Seticon(false)
      }
    }
  }

  const RemoveAll = () => {
    const DeletetagAll = arrayID.filter((item) => item !== item)
    SetarrayID(DeletetagAll)
  }

  const handleRemove = (id) => {
    if (role === false) {
      const newTag = arrayID.filter((item) => item.id !== id)
      SetarrayID(newTag)
      if (newTag.length <= 0) {
        return SetBinVisible(false)
      }
    }
  }
  const onFinish = (value) => {
    let ListID = []
    for (var i = 0; i < arrayID.length; i++) {
      ListID.push(arrayID[i].id)
    }

    const dataArray = {
      id: idEditPRJ,
      project_skill: `${ListID}`,
    }

    try {
      updateSkill({
        params: dataArray,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          SetisModalVisibleDraft(true)
          getDataProjectById()
          GetAccountByID()
          try {
            ACCOUNT_DELETE_API({
              params: dataArray,
              token: token,
            }).then((res) => {
              if (res.status === 200) {
                setDisLoadPage(false)
              }
            })
          } catch (error) {}
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleOkDraft = () => {
    SetisModalVisibleDraft(false)
  }
  const handleCancelDraft = () => {
    SetisModalVisibleDraft(false)
  }
  //--Save Draft

  useEffect(() => {
    if (token) {
      setPastnewData(arrayID)
    }
  }, [token, arrayID])

  return (
    <SkillContainer>
      <Helmet>
        <title>Create Project | Skill</title>
      </Helmet>
      <div className="header">
        <h2>Project Skills</h2>
      </div>
      <Form className="style-container-form-layout" form={form} onFinish={onFinish}>
        <Content>
          <Input
            prefix={<SearchOutlined />}
            placeholder="Search By Skill Name"
            type="text"
            value={SearchTerm}
            onChange={onChangeSearch}
            size="large"
            allowClear
          />
          {waitingallData === true ? (
            <div className="ContainerTitleSkill">
              <div className="numbertag-Container">
                {Selecttotal}
                <span className="text-selected">Skills Selected</span>
              </div>
              <div className="ShowSkillItem">
                {arrayID &&
                  arrayID.map((item, index) => {
                    return (
                      <div
                        key={item.id}
                        className="Box" // เอา conditional className ออก
                        onClick={() => eventtagFunctional('onetag', item.id)}
                        // เอา inline styles ออกทั้งหมด
                      >
                        <span
                          className="tagname"
                          title={item.isUnknown ? 'This skill data is not available' : ''}
                        >
                          {item.skill_name}
                          {item.isUnknown}
                        </span>
                        <img hidden={role} className="iconpath" src={path}></img>
                      </div>
                    )
                  })}
                {role === false ? (
                  <img
                    className={BinVisible ? 'bin' : 'activebin'}
                    src={bin}
                    onClick={() => eventtagFunctional('multitag')}
                  ></img>
                ) : (
                  ''
                )}
              </div>
            </div>
          ) : (
            ''
          )}
          {waitingallData === true ? (
            <Row className="ContainerAddSkill">
              {Data.filter((item) => {
                if (SearchTerm == '') {
                  return item
                } else if (item.title.toLowerCase().includes(SearchTerm.toLowerCase())) {
                  return item
                }
              }).map((data, index) => {
                let Focus = 0
                for (var i = 0; i < arrayID.length; i++) {
                  if (arrayID[i].id == data.id) {
                    Focus = data.id
                  }
                }
                return (
                  <div className={Selected && Focus ? 'border-select' : 'activeborder'}>
                    <Col
                      className="ItemSkillContainer"
                      id={`skill_${data.title}`}
                      onClick={() => handleEventSelected(data, using[data.id])}
                    >
                      <div className="area" style={{ width: '90%' }}>
                        <div className="row-area-nowrap">
                          <img className="smallicon" src={unknow}></img>
                          <Tooltip placement="bottom" title={data.title}>
                            <h3 className="font">{data.title}</h3>
                          </Tooltip>
                        </div>

                        <p>
                          {using[data.id] == undefined
                            ? ''
                            : `${using[data.id]} Members selected`}
                        </p>
                      </div>
                      <div
                        style={{
                          width: '10%',
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'flex-end',
                        }}
                      >
                        <CheckCircleOutlined
                          className={icon && Focus ? 'icons-select' : 'activeicons'}
                        />
                      </div>
                    </Col>
                  </div>
                )
                // }
              })}
              {/* {role === false ? (
                <>
                  <div className='Box-borderAdd' onClick={showModal} hidden={false}>
                    <PlusOutlined className='seticonsplus' />
                    <span className='Addnewskill'>Add New Skill</span>
                  </div>
                </>
              ) : (
                ''
              )} */}
            </Row>
          ) : (
            <div className="container-waiting-load">
              <img src={loadingAnimationthreedot}></img>
            </div>
          )}
        </Content>
        <Footer
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            backgroundColor: 'inherit',
            marginTop: 32,
          }}
        >
          <div>
            <Button
              id="previousskill"
              type="primary"
              ghost
              className="BTN_Previous"
              style={{ color: ColorList.blue }}
              onClick={(e) => checkDataskill_Func('previous')}
            >
              <LeftOutlined className="Icon-color" />
              Previous
            </Button>
            <Button
              id="nextskill"
              className="BTN_Next"
              style={{ marginLeft: 8 }}
              onClick={(e) => checkDataskill_Func('next')}
            >
              Next
              <RightOutlined className="Icon-color" />
            </Button>
          </div>
        </Footer>

        <EditModal
          className="add-skill-modal"
          title={<span className="Modaltitle">Add New Project Skills</span>}
          visible={isModalVisible}
          onOk={addItem}
          onCancel={handleCancel}
          okText="Save"
          okButtonProps={{ disabled: Disabled }}
        >
          <span style={{ display: 'flex', marginBottom: 8 }}>Skill name</span>
          <Input
            className="TextInput"
            placeholder="Please enter skill name"
            name="item"
            size="large"
            type="text"
            maxLength="60"
            minLength="5"
            value={ItemName}
            onChange={(e) => checkInputValue(e.target.value)}
          ></Input>
          <span className={WarningTxt ? 'small text-warning' : 'activeWarning'}>
            Same the name.
          </span>
        </EditModal>
        <Modal
          maskClosable={false}
          className="ModalSaveDraft"
          visible={isModalVisibleDraft}
          onOk={handleOkDraft}
          onCancel={handleCancelDraft}
        >
          <CheckCircleOutlined className="Icon-style" />
          <h2>Saved Succesfully</h2>
          <h4>Your project has been saved(draft)</h4>
        </Modal>
        <Modal
          className="ModalStatusOption"
          visible={isModalVisibleSkill}
          onOk={okEvent}
          onCancel={cancleEvent}
          okText="Confirm"
        >
          <CloseCircleOutlined className="CloseCircleOutlined " />
          <h2>Cancel Skill</h2>
          <h4>
            Are you sure to cancel the skill as it will also cause members with this skill
            to be removed ?
          </h4>
        </Modal>
      </Form>
    </SkillContainer>
  )
}
export default Skill
